// import { Mail, Phone, Instagram, Facebook, ArrowUpRight } from "lucide-react"
import { AppStoreIcon, EmailIcon, FacebookIcon, FacebookLogo, InstagramLogo, LandingEmailIcon, LandingFacebookIcon, LandingIgIcon, LandingPhoneIcon, PhoneIcon, PlayStoreIcon, UpIcon } from "../../../assets/icons";
import styles from "./LandingPageFooter.module.scss";

export default function Footer() {
	return (
		<footer className={styles.footerContainer}>
			{/* Faded background logo for desktop */}
			<div className={styles.backgroundWatermark}>
				{/* <img src={'../../../images/ekedc/logo.svg'} /> */}
			</div>

			<div className={styles.contentWrapper}>
				<div className={styles.gridContainer}>
					{/* Column 1: Logo, App Buttons, and CSR Text */}
					{/* <img className={styles.footerLogo} src={'../../../images/ekedc/logo.svg'} style={{width: '64px'}} /> */}
					<div className={styles.logoSection}>
						<div className={styles.logo}>
								<img src={'../../../images/ekedc/logo.svg'} style={{width: '64px'}}/>
						</div>
						<p className={styles.tagline}>Powering your Life, The smarter way!</p>
						<div className={styles.downloadCta}>
							<a href="/#" className={`${styles.downLoadLinkButton} ${styles.version2}`}>
								<PlayStoreIcon />
								<div>
									<p className={styles.text}>GET IT ON</p>
									<span className={styles.storeName}>Google Play</span>
								</div>
							</a>
							<a href="/#" className={`${styles.downLoadLinkButton} ${styles.version2}`}>
								<AppStoreIcon />
								<div>
									<p className={styles.text}>Download on the</p>
									<span className={styles.storeName}>App Store</span>
								</div>
							</a>
						</div>
						<p className={styles.italicText}>{"Every insight you gain helps light a bulb in a home still waiting for its first flicker of light."}</p>
						<p className={styles.csra}>
							Learn more about our CSR <a href="#" className={styles.linkHighlight}>here  <UpIcon/> {/* <ArrowUpRight className={styles.arrowIcon} /> */}</a>
							
						</p>
					</div>

					{/* Column 2: Quick as */}
					<div>
						<h3 className={styles.columnHeading}>Quick Links</h3>
						<ul className={styles.linkList}>
							<li>
								<a href="#" className={styles.linkItem}>
									Get Solar
								</a>
							</li>
							<li>
								<a href="#" className={styles.linkItem}>
									Features
								</a>
							</li>
							<li>
								<a href="#" className={styles.linkItem}>
									How it Works
								</a>
							</li>
							<li>
								<a href="#" className={styles.linkItem}>
									FAQs
								</a>
							</li>
						</ul>
					</div>

					{/* Column 3: Contact Us */}
					<div>
						<h3 className={styles.columnHeading}>Contact Us</h3>
						<ul className={styles.linkList}>
							<li className={styles.contactItem}>
								<LandingEmailIcon />
								<a href="mailto:support@xepp.co" className={styles.linkItem}>
									support@ekedp.co
								</a>
							</li>
							<li className={styles.contactItem}>
								<LandingPhoneIcon />
								<a href="tel:+2348026315444" className={styles.linkItem}>
									+2348026315444
								</a>
							</li>
						</ul>
						<div className={styles.socialIcons}>
							<a href="#" aria-label="Instagram">
								<LandingIgIcon />
							</a>
							<a href="#" aria-label="Facebook">
								<LandingFacebookIcon />
							</a>
						</div>
					</div>

					{/* Column 4: Become a Partner */}
					<div>
						<h3 className={styles.columnHeading}>Become a Partner</h3>
						<p className={styles.partnerLink}>
							Sign up <a href="#" className={styles.linkHighlight}>here <UpIcon/></a>
						</p>
					</div>
				</div>

				{/* Copyright */}
				<div className={styles.copyright}>© {new Date().getFullYear()} Beacon Power Services</div>
			</div>
		</footer>
	);
}
